import CalculationHelper from '../../../../components/admin/table_session/helper/CalculationHelper';
import TextHelper from '../../../../components/admin/table_session/helper/TextHelper';
import MerchantAppData from '../../../../Model/MerchantAppData';
import MerchantSettingKey from '../../../Common/Enum/MerchantSettingKey';

let _timer = null

const POLE_DISPLAY_API_URL = "http://localhost:8003/OrderLahDisplay"
const PATH_CLEAR = "/Clear"
const PATH_UPPER_LINE = "/DisplayUpperLine"
const PATH_BOTTOM_LINE = "/DisplayBottomLine"
const PATH_UPPER_LINE_CONTINUOUS = "/DisplayUpperLineContinues"
const PATH_BOTTOM_LINE_CONTINUOUS = "/DisplayLowerLineContinues"

const clearTimer = () => {
    if (_timer) {
        clearTimeout(_timer)
    }
}

let _defaultLines = {}
const defaultUpperLine = () => {
    return _defaultLines.upper || ""
}
const defaultBottomLine = () => {
    return _defaultLines.bottom || ""
}
const currentLines = {
    upper: "",
    lower: "",
}


let _upperLineTimer = null
let _lowerLineTimer = null
const API_REPEAT_INTERVAL = 2000
export default class PoleDisplay {
    constructor() {
        this.apiQueue = []
    }
    static withTimer = (interval) => {
        if (interval) {
            _poleDisplayWithTimer.setAutoResetTime(interval)
        }
        return _poleDisplayWithTimer
    }

    static getInstance = () => {
        return _poleDisplay
    }

    setDefaultLines = (defaultLine = {}) => {
        _defaultLines = defaultLine
    }

    /**
     * Pole display using Serial Port, thus we cannot just spam the API.
     * Need to "wait" for previous action to complete first
     */
    addApiToQueue = (ajaxOptions) => {
        // Add to queue
        this.apiQueue.push(ajaxOptions)

        // Trigger to fire API
        this.fireNextApi()
    }

    fireNextApi = () => {
        if (!this.waitingApi) {
            let ajaxOptions = this.apiQueue.shift()
            if (ajaxOptions) {
                this.waitingApi = true
                $.ajax({
                    ...ajaxOptions
                })
                .always(() => {
                    this.waitingApi = false
                    this.fireNextApi()
                })
            }
        }
        else {
            // Wait for current API to complete
            return
        }
    }

    /**
     * Wrap the function call in a wrapper. Extend this class
     * to define the wrapper function.
     * @param {Object} ajaxOptions - The parameters of $.ajax
     */
    wrapApi = (ajaxOptions) => {
        clearTimer()
        if (MerchantAppData.data.getMerchantSettingValue(MerchantSettingKey.HAS_POLE_DISPLAY) == 1) {
            this.addApiToQueue(ajaxOptions)
        }
    }

    /**
     * Show the price in pole display's second line
     * @param {Number} price
     */
    displayPrice = (price) => {
        price = CalculationHelper.round2dp(parseFloat(price)).toFixed(2)
        price = MerchantAppData.data.state.currencyName + " " + price

        // Update internal state
        currentLines.lower = price
        this.wrapApi({
            url     : POLE_DISPLAY_API_URL + PATH_BOTTOM_LINE,
            data    : {
                data: price
            }
        })
    }
    displayUpperLine = (text, apiCount = 0) => {
        // Update internal state
        currentLines.upper = text

        if (_upperLineTimer) {
            clearTimeout(_upperLineTimer)
        }

        // Keep spam to ensure the text displayed at Pole Display will
        // eventually be the latest text (API might fail, so we keep spam, up to 5 times)
        if (apiCount < 5) {
            _upperLineTimer = setTimeout(() => {
                this.displayUpperLine(currentLines.upper, apiCount + 1)
            }, API_REPEAT_INTERVAL);
        }

        this.wrapApi({
            url     : POLE_DISPLAY_API_URL + PATH_UPPER_LINE,
            data    : {
                data: currentLines.upper
            }
        })
    }
    displayBottomLine = (text, apiCount = 0) => {
        // Update internal state
        currentLines.lower = text

        if (_lowerLineTimer) {
            clearTimeout(_lowerLineTimer)
        }

        // Keep spam to ensure the text displayed at Pole Display will
        // eventually be the latest text (API might fail, so we keep spam, up to 5 times)
        if (apiCount < 5) {
            _lowerLineTimer = setTimeout(() => {
                this.displayBottomLine(currentLines.lower, apiCount + 1)
            }, API_REPEAT_INTERVAL);
        }

        this.wrapApi({
            url     : POLE_DISPLAY_API_URL + PATH_BOTTOM_LINE,
            data    : {
                data: currentLines.lower
            }
        })
    }
    displayUpperLineScroll = (text) => {

        if (_upperLineTimer) {
            clearTimeout(_upperLineTimer)
        }

        this.wrapApi({
            url     : POLE_DISPLAY_API_URL + PATH_UPPER_LINE_CONTINUOUS,
            data    : {
                data: text
            }
        })
    }
    displayBottomLineScroll = (text) => {

        if (_lowerLineTimer) {
            clearTimeout(_lowerLineTimer)
        }

        this.wrapApi({
            url     : POLE_DISPLAY_API_URL + PATH_BOTTOM_LINE_CONTINUOUS,
            data    : {
                data: text
            }
        })
    }

    clear = () => {
        clearTimer()

        // Fire this API without wrapping
        this.addApiToQueue({
            url     : POLE_DISPLAY_API_URL + PATH_CLEAR,
        })
    }

    showDefaultText = () => {
        _poleDisplay.displayUpperLine(defaultUpperLine())
        _poleDisplay.displayBottomLine(defaultBottomLine())
    }


    showOrderDetail = (order) => {
        let upperLine = `${order.quantity || 1} x ${TextHelper.onlyAscii(order.desc || "")}`
        PoleDisplay.withTimer().displayUpperLine(upperLine)
        PoleDisplay.withTimer().displayPrice(order.order_total || 0)
    }
}

const defaultAutoResetTime = 15000
class PoleDisplayWithTimer extends PoleDisplay {
    autoResetTime = defaultAutoResetTime

    /**
     * Set the auto reset time for the next wrapApi call. Then
     * the autoResetTime will be reverted back to default value
     */
    setAutoResetTime = (interval) => {
        this.autoResetTime = interval
    }

    /**
     * Wrap the function call in a wrapper. Extend this class
     * to define the wrapper function.
     * @param {Function} func
     */
     wrapApi = (func) => {
        clearTimer()
        this.addApiToQueue(func)
        _timer = setTimeout(() => {
            this.showDefaultText()
        }, this.autoResetTime)

        // Reset the auto reset time
        this.autoResetTime = defaultAutoResetTime
    }
}

const _poleDisplay = new PoleDisplay()
const _poleDisplayWithTimer = new PoleDisplayWithTimer()